import {
  faBacterium,
  faFlaskVial,
  faGlasses,
  faHeadSideMask,
  faHelmetUn,
  faMapLocationDot,
  faPersonFalling,
  faScrewdriverWrench,
  faSprayCan,
  faUserTie,
  faVest,
  faVestPatches,
  faWalkieTalkie
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  BluetoothDrive,
  Campaign,
  CleanHands,
  ConnectWithoutContact,
  Deblur,
  Diversity3,
  DriveEta,
  EmojiNature,
  FormatColorReset,
  GppMaybe,
  Headphones,
  Healing,
  Hearing,
  HomeRepairService,
  Hotel,
  LocalDrink,
  LocalFlorist,
  Map,
  Masks,
  MedicalServices,
  Navigation,
  Pets,
  Report,
  SignalCellularNodata,
  Sports,
  SportsMma,
  Thunderstorm,
  Traffic,
  Visibility,
  Water
} from '@mui/icons-material';
import HikingIcon from '@mui/icons-material/Hiking';
import KitesurfingIcon from '@mui/icons-material/Kitesurfing';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import React from 'react';
import {
  GiBeltArmor,
  GiChelseaBoot,
  GiFishingBoat,
  GiLifeBuoy,
  GiMetalBoot,
  GiRubberBoot,
  GiTreeBranch,
  GiWireCoil
} from 'react-icons/gi';
import '../../constants';
import {
  APPROPRIATE_CLOTHING,
  BEAR_SPRAY,
  BEES_WASPS,
  BIO_HAZARDS,
  BOATING,
  BOAT_SAFETY_KIT,
  BUG_SPRAY,
  CAULK_BOOTS,
  CHEMICAL_HAZARDS,
  COMM_PLAN,
  CUTS_ABRASIONS_STRAINS, DEHYDRATION,
  DISTRACTED_DRIVING,
  EAR_PROTECTION,
  EPIPEN,
  EQUIPMENT_USE,
  FATIGUE,
  FIRST_AID_KIT, GLOVES, GPS_MAP,
  HAND_RADIOS, HAND_SAN_WIPES, HARD_HAT,
  HI_VIS_VEST,
  IN_REACH_SPOT, LIFE_JACKET,
  MAKE_NOISE, MANAGE_ATTRACTANTS,
  MASK,
  NAVIGATION_LOST,
  NOISE, NOXIOUS_PLANTS, OBJ_IN_EYE,
  OVERHEAD_HAZARDS,
  PANDEMIC_ILLNESS,
  REMOTE_AREA,
  RESOURCE_MATERIAL,
  ROAD_CONDITIONS,
  SAFETY_GOGGLES,
  SIGNAGE,
  SLIPS_TRIPS_FALLS,
  STEEL_TOED_BOOTS,
  STURDY_FOOTWEAR,
  SWIFT_WATER,
  THROW_LINE,
  TRA_VEH_MACHINERY,
  WADERS,
  WADING_STAFF,
  WATER,
  WEATHER_EXPOSURE,
  WHISTLE,
  WILDLIFE_DOGS, WORKING_WATER,
  WORK_IN_GROUPS
} from '../../constants';

const ICON_SIZE = 40;

let iconsDict = [
  {
    name: REMOTE_AREA,
    control_measures: [FIRST_AID_KIT, WHISTLE, GPS_MAP, IN_REACH_SPOT, COMM_PLAN].sort(),
    icon: <SignalCellularNodata sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: WEATHER_EXPOSURE,
    control_measures: [APPROPRIATE_CLOTHING].sort(),
    icon: <Thunderstorm sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: WORKING_WATER,
    control_measures: [LIFE_JACKET, THROW_LINE, WADING_STAFF].sort(),
    icon: <Water sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: OVERHEAD_HAZARDS,
    control_measures: [HARD_HAT].sort(),
    icon: <GiTreeBranch style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: TRA_VEH_MACHINERY,
    control_measures: [HARD_HAT, HI_VIS_VEST, SAFETY_GOGGLES, EAR_PROTECTION, STEEL_TOED_BOOTS, STURDY_FOOTWEAR].sort(),
    icon: <DriveEta sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: ROAD_CONDITIONS,
    control_measures: [HAND_RADIOS].sort(),
    icon: <Traffic sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: CUTS_ABRASIONS_STRAINS,
    control_measures: [CAULK_BOOTS, GLOVES, FIRST_AID_KIT, STURDY_FOOTWEAR, APPROPRIATE_CLOTHING].sort(),
    icon: <Healing sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: SLIPS_TRIPS_FALLS,
    control_measures: [CAULK_BOOTS, FIRST_AID_KIT, STURDY_FOOTWEAR].sort(),
    icon: <FontAwesomeIcon icon={faPersonFalling} style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: OBJ_IN_EYE,
    control_measures: [SAFETY_GOGGLES, FIRST_AID_KIT].sort(),
    icon: <Visibility sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: FATIGUE,
    control_measures: [WATER].sort(),
    icon: <Hotel sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: DEHYDRATION,
    control_measures: [WATER].sort(),
    icon: <FormatColorReset sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: NOXIOUS_PLANTS,
    control_measures: [SAFETY_GOGGLES, GLOVES, MASK, HAND_SAN_WIPES, APPROPRIATE_CLOTHING].sort(),
    icon: <LocalFlorist sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: BEES_WASPS,
    control_measures: [APPROPRIATE_CLOTHING, EPIPEN].sort(),
    icon: <EmojiNature sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: CHEMICAL_HAZARDS,
    control_measures: [SAFETY_GOGGLES, MASK, APPROPRIATE_CLOTHING, WATER, SIGNAGE].sort(),
    icon: <FontAwesomeIcon icon={faFlaskVial} style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: WILDLIFE_DOGS,
    control_measures: [BEAR_SPRAY, FIRST_AID_KIT, MAKE_NOISE, MANAGE_ATTRACTANTS, WORK_IN_GROUPS].sort(),
    icon: <Pets sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: BIO_HAZARDS,
    control_measures: [SAFETY_GOGGLES, GLOVES, FIRST_AID_KIT, COMM_PLAN, MASK, HAND_SAN_WIPES, APPROPRIATE_CLOTHING, WATER, SIGNAGE].sort(),
    icon: <FontAwesomeIcon icon={faBacterium}  style={{ fontSize: ICON_SIZE }}/>
  },
  {
    name: NAVIGATION_LOST,
    control_measures: [HI_VIS_VEST, GLOVES, FIRST_AID_KIT, WHISTLE, GPS_MAP, IN_REACH_SPOT, COMM_PLAN, APPROPRIATE_CLOTHING, WATER, HAND_RADIOS].sort(),
    icon: <Navigation sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: NOISE,
    control_measures: [EAR_PROTECTION].sort(),
    icon: <Hearing sx={{ fontSize: ICON_SIZE }} />,
  },
  {
    name: EQUIPMENT_USE,
    control_measures: [HARD_HAT, HI_VIS_VEST, SAFETY_GOGGLES, CAULK_BOOTS, EAR_PROTECTION,
      GLOVES, FIRST_AID_KIT, STEEL_TOED_BOOTS, STURDY_FOOTWEAR, APPROPRIATE_CLOTHING].sort(),
    icon: <HomeRepairService sx={{ fontSize: ICON_SIZE }} />,
  },
  {
    name: DISTRACTED_DRIVING,
    control_measures: [].sort(),
    icon: <BluetoothDrive sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: BOATING,
    control_measures: [WADERS, BOAT_SAFETY_KIT, LIFE_JACKET].sort(),
    icon: <GiFishingBoat style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: SWIFT_WATER,
    control_measures: [LIFE_JACKET, THROW_LINE, WADING_STAFF].sort(),
    icon: <KitesurfingIcon sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: PANDEMIC_ILLNESS,
    icon: <FontAwesomeIcon icon={faHeadSideMask} style={{ fontSize: ICON_SIZE }} />,
    control_measures: [
      SAFETY_GOGGLES,
      GLOVES,
      MASK,
      HAND_SAN_WIPES,
      WATER
    ].sort()
  },
  {
    name: HARD_HAT,
    icon: <FontAwesomeIcon icon={faHelmetUn} style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: GLOVES,
    icon: <SportsMma sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: GPS_MAP,
    icon: <Map sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: HAND_SAN_WIPES,
    icon: <CleanHands sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: BUG_SPRAY,
    icon: <FontAwesomeIcon icon={faSprayCan} style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: HI_VIS_VEST,
    icon: <FontAwesomeIcon icon={faVestPatches} style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: FIRST_AID_KIT,
    icon: <MedicalServices sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: IN_REACH_SPOT,
    icon: <FontAwesomeIcon icon={faMapLocationDot} style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: APPROPRIATE_CLOTHING,
    icon: <FontAwesomeIcon icon={faUserTie} style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: RESOURCE_MATERIAL,
    icon: <FontAwesomeIcon icon={faScrewdriverWrench} style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: SAFETY_GOGGLES,
    icon: <FontAwesomeIcon icon={faGlasses} style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: WHISTLE,
    icon: <Sports sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: THROW_LINE,
    icon: <GiWireCoil style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: WATER,
    icon: <LocalDrink sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: EPIPEN,
    icon: <VaccinesIcon sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: CAULK_BOOTS,
    icon: <GiRubberBoot style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: LIFE_JACKET,
    icon: <FontAwesomeIcon icon={faVest} style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: COMM_PLAN,
    icon: <ConnectWithoutContact sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: HAND_RADIOS,
    icon: <FontAwesomeIcon icon={faWalkieTalkie} style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: EAR_PROTECTION,
    icon: <Headphones sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: STEEL_TOED_BOOTS,
    icon: <GiMetalBoot style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: STURDY_FOOTWEAR,
    icon: <GiChelseaBoot style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: MASK,
    icon: <Masks sx={{ fontSize: ICON_SIZE }} />
  },
  {
    name: SIGNAGE,
    icon: <Report sx={{ fontSize: ICON_SIZE }} />,
  },
  {
    name: WADERS,
    icon: <GiBeltArmor style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: BOAT_SAFETY_KIT,
    icon: <GiLifeBuoy style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: WADING_STAFF,
    icon: <HikingIcon style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: BEAR_SPRAY,
    icon: <FontAwesomeIcon icon={faSprayCan} style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: WORK_IN_GROUPS,
    icon: <Diversity3 style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: MANAGE_ATTRACTANTS,
    icon: <Deblur style={{ fontSize: ICON_SIZE }} />
  },
  {
    name: MAKE_NOISE,
    icon: <Campaign style={{ fontSize: ICON_SIZE }} />
  },

]

export function getIcon(name) {
  let icon = iconsDict.find((icon) => icon.name === name);
  if (icon) {
    return icon.icon;
  } else {
    return <GppMaybe sx={{ fontSize: ICON_SIZE }} />
  }
}

export function getControlMeasures(name) {
  let icon = iconsDict.find((icon) => icon.name === name);
  return icon?.control_measures ?? [];
}